import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "ayushman_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// ---------- Public ----------
export const fetchProducts = () => api.get("/products").then((r) => r.data);
export const fetchCompany = () => api.get("/company").then((r) => r.data);
export const submitContact = (payload) =>
  api.post("/contact", payload).then((r) => r.data);

// ---------- Auth ----------
export const loginAdmin = (password) =>
  api.post("/auth/login", { password }).then((r) => r.data);
export const fetchMe = () => api.get("/auth/me").then((r) => r.data);

// ---------- Admin ----------
export const adminListProducts = () =>
  api.get("/admin/products").then((r) => r.data);
export const adminCreateProduct = (data) =>
  api.post("/admin/products", data).then((r) => r.data);
export const adminUpdateProduct = (id, data) =>
  api.put(`/admin/products/${id}`, data).then((r) => r.data);
export const adminDeleteProduct = (id) =>
  api.delete(`/admin/products/${id}`).then((r) => r.data);
export const adminListContact = () =>
  api.get("/admin/contact").then((r) => r.data);
export const adminDeleteContact = (id) =>
  api.delete(`/admin/contact/${id}`).then((r) => r.data);

export const adminExportContactCSV = async () => {
  const res = await api.get("/admin/contact/export.csv", { responseType: "blob" });
  const today = new Date().toISOString().slice(0, 10);
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `pediarange-contacts-${today}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export const adminUploadFile = async (file, onProgress) => {
  const fd = new FormData();
  fd.append("file", file);
  const res = await api.post("/admin/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (evt) => {
      if (onProgress && evt.total) onProgress(Math.round((evt.loaded / evt.total) * 100));
    },
  });
  // Backend returns a relative URL (`/api/files/...`); compose absolute URL
  // using the public BACKEND_URL so <img src> works on the public site.
  const data = res.data;
  const url = data.url?.startsWith("http")
    ? data.url
    : `${BACKEND_URL}${data.url}`;
  return { ...data, url };
};

export const changePassword = (current_password, new_password) =>
  api
    .post("/auth/change-password", { current_password, new_password })
    .then((r) => r.data);

export const formatApiError = (e) => {
  const detail = e?.response?.data?.detail;
  if (!detail) return e?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((d) => (d && typeof d.msg === "string" ? d.msg : JSON.stringify(d)))
      .join(" · ");
  return String(detail);
};
